(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignTcpashieldFilter', {
    bindings: {
      tcpaEnabled: '<',
      playMessage: '<',
      canSave: '<',
      onSave: '&'
    },
    controller: CampaignTcpashieldFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/campaigns/campaign-tcpashield-filter.component.html'
  });

  function CampaignTcpashieldFormController(
    accountSettingsService,
    accountsService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.saveSettings = saveSettings;
    vm.onTcpaToggleChanged = onTcpaToggleChanged;
    vm.onPlayMessageToggleChanged = onPlayMessageToggleChanged;
    vm.accountSettings = {};

    function onInit() {
      accountSettingsService.loadSettings(accountsService.currentAccountId)
        .then(function (response) {
          vm.accountSettings = response.data.accountSettings;
        });
    }

    function saveSettings() {
      return vm.onSave({ settings: {playTCPAWarningMessage: vm.playMessage, filterCallsThroughTCPAShield: vm.tcpaEnabled } });
    }

    function onTcpaToggleChanged(isTcpaEnabled) {
      vm.tcpaEnabled = isTcpaEnabled;
    }

    function onPlayMessageToggleChanged(playTCPAWarningMessage) {
      vm.playMessage = playTCPAWarningMessage;
    }
  }
})();
